import {Component, Input} from '@angular/core';
import {EntityService} from "@signature-it/ngx-entity/services";
import {EntityTreeData} from "@signature-it/ngx-entity/types";

@Component({
    selector: 'tree-accordion',
    templateUrl: './tree-accordion.component.html',
    styleUrls: ['./tree-accordion.component.scss'],
    standalone: false
})
export class TreeAccordionComponentGeneric {
    @Input() entityTreeData: EntityTreeData;
    @Input() showTitle: boolean = false;
    htmlData = {};

    constructor(protected entityService: EntityService) {}

    getHtml(uri, type_var) {
        if(!this.htmlData[uri]) {
            this.entityService.getEntityHtml(uri, type_var).subscribe(
                res => {
                    if(res) {
                        this.htmlData[uri] = res;
                    }
                }
            )
        }
    }
}
